import Pixify from '../assets/projects/Pixify.png'
import Flutter from '../assets/projects/flutter.png'
import Twitch from '../assets/projects/Twitch.png'
import meesho from '../assets/projects/meesho.png'
import tattoo from '../assets/projects/tattoo.png'
import watsapp from '../assets/projects/watsapp.png'
import sailfire from '../assets/projects/sailfire.png'
import bluebird from '../assets/projects/bluebird.png'
import quiz from '../assets/projects/quiz.png'


export const data=[
    {
        id:1,
        name:"Flutter",
        image:Flutter,
        github:"https://github.com/Fizz007/Flutter.git",
        live:"https://flutter-rho.vercel.app/",
    },
    {
        id:2,
        name:"Pixify",
        image:Pixify,
        github:"https://github.com/Fizz007/Pixify.git",
        live:"https://pixify-eight.vercel.app/",
    },
    {
        id:3,
        name:"Twitch",
        image:Twitch,
        github:"https://github.com/Fizz007/Twitch.git",
        live:"https://twitch-navy.vercel.app/",
    },
    {
        id:4,
        name:"Meesho Clone",
        image:meesho,
        github:"https://github.com/Fizz007/Meesho-Clone---React-Project---xwdbuwmdhfg8.git",
        live:"https://meesho-clone-alpha.vercel.app/",
    },
    {
        id:5,
        name:"Void Tattoo",
        image:tattoo,
        github:"https://github.com/Fizz007/TATTOO.gitt",
        live:"https://tattoo-git-main-sailfire.vercel.app/",
    },
    {
        id:6,
        name:"Whatsapp Clone",
        image:watsapp,
        github:"https://github.com/Fizz007/Whats-App-Clone---React-Project---wxywu9xmz0qk.git",
        live:"https://whats-app-clone-react-project-wxywu9xmz0qk.vercel.app/",
    },
    {
        id:7,
        name:"Sailfire Blogg",
        image:sailfire,
        github:"https://github.com/Fizz007/Sailfire_blogg.git",
        live:"https://sailfire-blogg.vercel.app/",
    },
    {
        id:8,
        name:"Bluebird movies",
        image:bluebird,
        github:"https://github.com/Fizz007/Bluebird_movies.git",
        live:"https://bluebird-movies.vercel.app/",
    },
    {
        id:8,
        name:"Quiz App",
        image:quiz,
        github:"https://github.com/Fizz007/Traveey_task.git",
        live:"https://traveey-task.vercel.app/",
    },


]
